import { useState, useEffect } from 'react';

import { useThemeObserver } from '@atlaskit/tokens';

// There was a layout shift when the live doc modal was loading the gif, this
// hook is used to preload the gif before popping the modal.
export const usePreloadImage = (src: { light: string; dark: string }) => {
	const { colorMode } = useThemeObserver();
	const imgSrc = colorMode === 'dark' ? src.dark : src.light;
	const [preloading, setPreloading] = useState(true);
	useEffect(() => {
		const image = new Image();

		image.onload = () => {
			setPreloading(false);
		};

		image.onerror = () => {
			setPreloading(false);
		};

		image.src = imgSrc;

		// If the image has already loaded, it may not trigger the onload event
		// so we can set preloading to false immediately.
		if (image.complete) {
			setPreloading(false);
		}
	}, [imgSrc]);

	return preloading;
};
